/**
 * Executa `worker` sobre `items` com no maximo `limit` chamadas em voo.
 *
 * `Promise.all` dispara tudo de uma vez, e `for...of` com `await` dispara uma por vez. Aqui o
 * meio: serve para quebrar uma chamada grande em varias por empresa sem trocar um pico de
 * payload por um pico de requisicoes simultaneas.
 *
 * Devolve os resultados na ordem de `items`. Se um worker rejeita, a promessa rejeita -- as
 * chamadas ja em voo terminam, mas nenhuma nova comeca.
 */
export async function mapWithConcurrency(items = [], limit = 1, worker) {
    const list = [].concat(items);
    const results = new Array(list.length);
    const emVoo = Math.max(1, Math.min(Number(limit) || 1, list.length));
    let proximo = 0;

    const consumir = async () => {
        while (proximo < list.length) {
            const indice = proximo++;
            results[indice] = await worker(list[indice], indice);
        }
    };

    await Promise.all(Array.from({ length: emVoo }, consumir));

    return results;
}
